// v2.17.2 (owner 2026-10-23): a station is shown by its readable name ("Press Satuan"), never by its
// code (OP_PRESS_SATUAN). The names come from the station master (Owner can rename a station); the
// name saved on the SPK step is the fallback, then a tidied code. Pure helpers (no imports) for Jest.

// {code: name} from the station master list (GET /pos-produksi)
export function petaPos(list) {
  return Object.fromEntries((list || []).filter((p) => p && p.code && p.nama).map((p) => [p.code, p.nama]));
}

const KHUSUS = { TIDAK_DIKETAHUI: "tidak diketahui" };

// OP_PRESS_SATUAN → "Press Satuan" (only while the master list is still loading or misses the code)
export function rapikanKode(code) {
  return String(code).replace(/^OP_/, "").split("_").filter(Boolean)
    .map((w) => (w.length <= 3 ? w : w[0] + w.slice(1).toLowerCase())).join(" ");
}

// the readable name of one station; `cadangan` = the name saved on the step
export function namaPos(code, peta, cadangan) {
  if (!code) return cadangan || "";
  return (peta || {})[code] || KHUSUS[code] || cadangan || rapikanKode(code);
}

// a workflow step with its alternative stations: "Press Satuan / Press Roll"
export function namaLangkah(step, peta) {
  if (!step) return "";
  return [namaPos(step.pos_code, peta, step.pos_nama), ...(step.alternatif || []).map((c) => namaPos(c, peta))].join(" / ");
}
